// Vendor JS
import Debug from 'debug';
import * as FilePond from 'filepond';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';

class AvatarUploader {
	init = () => {
		try {
			Debug(`cig:info:sage:class:AvatarUploader`)(`init start`);

			this.filePondMagic();
		} catch (err) {
			Debug(`cig:error:sage:class:AvatarUploader`)(`init Error: %s %o`, err.message, err);
		}
	}

	filePondMagic = () => {
		try {
			const elUploader = document.querySelector(`input[name="avatar_upload"]`);

			Debug(`cig:info:sage:class:AvatarUploader`)(`filePondMagic avatar_upload element: %o`, elUploader);

			if (elUploader !== null) {
				// We need to register the required plugins to do image manipulation and previewing.
				FilePond.registerPlugin(
					// // encodes the file as base64 data
					FilePondPluginFileEncode,

					// validates files based on input type
					FilePondPluginFileValidateType,

					// corrects mobile image orientation
					FilePondPluginImageExifOrientation,

					// previews the image
					FilePondPluginImagePreview,

					// crops the image to a certain aspect ratio
					FilePondPluginImageCrop,

					// resizes the image to fit a certain size
					FilePondPluginImageResize,
				);

				const preloadFiles = elUploader && elUploader.dataset.avatar
					? [
						{
							source: elUploader.dataset.avatar,
							options: {
								type: 'local'
							}
						}
					]
					: [];

				const userId = elUploader.dataset.userid;

				// Select the file input and use create() to turn it into a pond
				// in this example we pass properties along with the create method
				// we could have also put these on the file input element itself
				FilePond.create(
					elUploader,
					{
						labelIdle: `Drop your picture or <span class="filepond--label-action">Browse</span>`,
						imagePreviewHeight: 170,
						imageCropAspectRatio: '1:1',
						imageResizeTargetWidth: 200,
						imageResizeTargetHeight: 200,
						stylePanelLayout: 'compact circle',
						styleLoadIndicatorPosition: 'center bottom',
						styleButtonRemoveItemPosition: 'center bottom',
						styleProgressIndicatorPosition: 'center bottom',
						styleButtonProcessItemPosition: 'center bottom',
						acceptedFileTypes: ['image/*'],
						allowMultiple: false,
						files: preloadFiles,
						server: {
							load: (source, load) => {
								//  pulling from preloadFiles source
								const myRequest = new Request(source);

								//  get user's avatar img data
								fetch(myRequest, {
									method: 'GET'
								}).then((response) => {
									response.blob().then((myBlob) => {
										load(myBlob);
									});
								});
							},
							process: (fieldName, file, metadata, load, error, progress, abort) => {

								// fieldName is the name of the input field
								// file is the actual file object to send
								const formData = new FormData();
								formData.append(fieldName, file, file.name);
								formData.append('guid', userId);

								const request = new XMLHttpRequest();
								request.open('POST', `/wp-ajax/?action=cig_avatar_upload`);

								// Should call the progress method to update the progress to 100% before calling load
								// Setting computable to false switches the loading indicator to infinite mode
								request.upload.onprogress = (e) => {
									progress(e.lengthComputable, e.loaded, e.total);
								};

								// Should call the load method when done and pass the returned server file id
								// this server file id is then used later on when reverting or restoring a file
								// so your server knows which file to return without exposing that info to the client
								request.onload = () => {
									if (request.status >= 200 && request.status < 300 && request.responseText) {
										const responseData = JSON.parse(request.responseText);
										const avatarUrl = responseData.url;

										if (avatarUrl) {
											document.querySelector("input[name='avatar_url']").value = avatarUrl;
											load(request.responseData);
										}
									}
									else {
										// Can call the error method if something is wrong, should exit after
										error('Unable to upload avatar');
									}
								};

								request.send(formData);

								// Should expose an abort method so the request can be cancelled
								return {
									abort: () => {
										// This function is entered if the user has tapped the cancel button
										request.abort();

										// Let FilePond know the request has been cancelled
										abort();
									}
								};
							}
						}
					}
				);
			}
		} catch (err) {
			Debug(`cig:error:sage:class:AvatarUploader`)(`filePondMagic Error: %s %o`, err.message, err);
		}
	}
}

export default new AvatarUploader();
